module.exports = __webpack_public_path__ + "static/media/minus-symbol.eef388d8.svg";